// Copyright (c) 2019 Deere & Company

import './success-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import PropTypes from 'prop-types';
import React from 'react';

export const SuccessAlertBar = props => (
    <div className="success-alert-bar">
        <AlertBarBase
            alertTitle={props.alertTitle}
            canDismiss={props.canDismiss}
            dismissHandler={props.dismissHandler}
            iconClass="icon-checkmark"
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>
);

SuccessAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    canDismiss: PropTypes.bool,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool,
};

SuccessAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: true,
};
